/* eslint react/no-multi-comp: 0, no-unused-vars: 0 */

import React from 'react';
import { Section, preloader } from 'spectacle-ppa';
import Regionalization from '../../../../src/services/regionalization';

import balloonSlide from '../../baseSlides/balloonSlide';
import headingSlide from '../../baseSlides/headingSlide';
import videoSlide from '../../baseSlides/videoSlide';

import imageGameshowTitle from './title_gameshow.png';
import imageGameshowPlayers from './title_gameshow_players.png';

import ianSaraLeanSmile from '../../images/characters/ian_sara_lean_smile.png';
import ianSide from '../../images/characters/ian_side.png';
import saraSmile from '../../images/characters/sara_smile.png';
import ianShrugLaugh from '../../images/characters/ian_shrug_laugh.png';
import ianPointingUp from '../../images/characters/ian_pointing_up.png';
import ianSaraLeanQuestion from '../../images/characters/ian_sara_lean_questioning.png';
import saraSurprised from '../../images/characters/sara_surprised.png';
import ianSaraSide from '../../images/characters/ian_sara_side.png';

import MarkdownScript from 'helpers/markdownScript';
import markdownFileLevel1 from './level1_knowTheRisks.md';
import markdownFileLevel2 from './level2_makeAPlan.md';
import markdownFileLevel3 from './level3_getAKit.md';
import markdownFileLevel4 from './level4_wereInThisTogether.md';

const levels = {
  '1': { md: new MarkdownScript(markdownFileLevel1) },
  '2': { md: new MarkdownScript(markdownFileLevel2) },
  '3': { md: new MarkdownScript(markdownFileLevel3) },
  '4': { md: new MarkdownScript(markdownFileLevel4) }
};

export function preloadGameShow () {
  preloader([
    imageGameshowTitle,
    imageGameshowPlayers,
    ianSaraLeanSmile,
    ianSide,
    saraSmile,
    ianShrugLaugh,
    ianSaraLeanQuestion,
    saraSurprised,
    ianSaraSide
  ]);
}

function intro (level, regionData) {
  const md = levels[level].md;
  return videoSlide({
    id: 'intro',
    notes: md.getSubSectionAsHtml('Intro Video', 'Notes', false, regionData),
    youTubeId: md.getSectionMetadata('Intro Video', 'YouTube', regionData)
  });
}

function sizzle (level, regionData) {
  const md = levels[level].md;
  return headingSlide({
    id: 'sizzle',
    bgColor: '#742CBF',
    afterImage: imageGameshowTitle,
    notes: md.getSubSectionAsHtml('Sizzle', 'Notes', false, regionData)
  });
}

function scoring (level, regionData) {
  const md = levels[level].md;
  return balloonSlide({
    id: 'scoring',
    characterSide: 'left',
    characterImage: ianSaraLeanSmile,
    notes: md.getSubSectionAsHtml('Scoring', 'Notes', false, regionData),
    html: md.getSubSectionAsHtml('Scoring', 'Content', false, regionData),
    bgColor: '#742CBF'
  });
}

function questionSlide ({
    level,
    questionNumber,
    numQuestions,
    md,
    questionCharacterImage,
    answerCharacterImage,
    regionData}) {
  const questionSection = `Question ${questionNumber}`;
  const defaultRegion = md.getSectionMetadata(questionSection,
                                              'Default Region',
                                              regionData);
  const questionCharacter = !questionCharacterImage ? ianSide : questionCharacterImage;
  const answerCharacter = !answerCharacterImage ? saraSmile : answerCharacterImage;
  let answer;
  if (defaultRegion) {
    answer = md.getSubSectionAsHtml(
                questionSection, `Answer - ${defaultRegion}`, false, regionData);
  } else {
    answer = md.getSubSectionAsHtml(questionSection, 'Answer', false, regionData);
  }
  const answerNotes = md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData);

  return [

    // four players announcement
    headingSlide({
      id: `${questionNumber}-four-players`,
      afterImage: imageGameshowPlayers,
      bgColor: 'black',
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        md.getSubSectionAsHtml(
          'Four Players Announcement',
          'Notes',
          false, regionData
        )
    }),

    // additional slide for level 4, question 3
    (level === 4 && questionNumber === 3)
    ? balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: ianSide,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-multiple-choice`,
      html: md.getSubSectionAsHtml(questionSection, 'Question Intro', false, regionData),
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        `<br />` +
        `<p style="font color: white">Multiple choice, see next slide</h4>`,
      bgColor: '#45B3EC'
    })
    : null,

    // question text
    balloonSlide({
      balloonType: `question`,
      characterSide: `left`,
      characterImage: questionCharacter,
      questionNumber,
      numQuestions,
      id: `${questionNumber}-question`,
      html: md.getSubSectionAsHtml(questionSection, 'Question', false, regionData),
      notes: `<h2>Question ${questionNumber} of ${numQuestions}: </h2>` +
        `<br />` +
        `<p style="font color: white">Preview of next slide/answer</h4>` +
        answer
    }),

    // answer slide
    balloonSlide({
      balloonType: `answer`,
      characterSide: `right`,
      characterImage: answerCharacter,
      questionNumber,
      id: `${questionNumber}-answer`,
      html: answer,
      notes: `<h2>Answer ${questionNumber} of ${numQuestions}</h2>` +
         `<br />` +
         ( !answerNotes.match(/SKIP/) ?
           md.getSubSectionAsHtml(questionSection, 'Answer Notes', false, regionData)
           : ''
         )
    })
  ];
}

function endOfGameShow (level) {
  return balloonSlide({
    id: 'end',
    characterSide: 'left',
    characterImage: ianShrugLaugh,
    bgColor: '#742CBF',
    html: `<h3>Level ${level} Game Show Completed!</h3>`,
    notes: 'Game show completed.'
  });
}

function level1 (regionData) {
  const level = 1;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'left',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level2 (regionData) {
  const level = 2;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData })}

      {/* Scoring reminder */}
      {balloonSlide({
        id: 'scoring-reminder',
        characterSide: 'left',
        characterImage: ianPointingUp,
        notes: md.getSubSectionAsHtml('Scoring Reminder', 'Notes', false, regionData),
        html: md.getSubSectionAsHtml('Scoring Reminder', 'Content', false, regionData),
        bgColor: '#742CBF'
      })}

      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level3 (regionData) {
  const level = 3;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Scoring intro */}
      {scoring(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function level4 (regionData) {
  const level = 4;
  const md = levels[level].md;

  return (
    <Section id="game-show">

      {/* Sara and Ian introduce the Game Show */}
      {intro(level, regionData)}

      {/* Sizzle */}
      {sizzle(level, regionData)}

      {/* Game show questions */}
      {questionSlide({ level, questionNumber: 1, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 2, numQuestions: 3, md, regionData })}
      {questionSlide({ level, questionNumber: 3, numQuestions: 3, md, regionData })}

      {/* End of Game Show */}
      {endOfGameShow(level)}

    </Section>
  );
}

function gameShowSection ({ level, regionData }) {
  switch (level) {
  case 1:
    return level1(regionData);
  case 2:
    return level2(regionData);
  case 3:
    return level3(regionData);
  case 4:
    return level4(regionData);
  default:
    return headingSlide({ heading: 'Unknown' });
  }
}

export default gameShowSection;



// WEBPACK FOOTER //
// ./programs/epsPrimaries/sections/20_gameShow/gameShowSection.jsx